export default "__VITE_ASSET__DZBrCES4__"